export default "https://cdn-static.gokick.com/assets/1c04a0e7cb9e690604c984af7e1d0f36647cf8e0/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";